<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width="800" content-class="round-2xl")
  v-card
    v-card-title.px-4.py-3
      v-row(no-gutters align="center")
        v-col(cols="10" offset="1")
          .text-md.font-semibold.text-center Family relation
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      family-listing(:patientId="patientId" @updated="$emit('updated')")

</template>

<script>
import FamilyListing from '@/components/clinic/relationship/FamilyListing.vue'

export default {
  components: {
    FamilyListing,
  },
  props: {
    open: {
      type: Boolean,
    },
    patientId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
    handleDelete () {
      this.loading = true
      this.$emit('delete')
    }
  },
}
</script>